// extracted by mini-css-extract-plugin
export var builderImageWrapper = "testimonial-module--builder-image-wrapper--a2b92";
export var changeMarginToPadding = "testimonial-module--change-margin-to-padding--82d74";
export var left = "testimonial-module--left--f04e6";